import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getDevicesAPI } from './api';

export const GET_DEVICES = 'getDevices';

export function useGetDevices() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_DEVICES, tenantId,
  ], () => getDevicesAPI());

  return {
    devices: data?.devices || [],
    isLoading,
    isFetching,
    isError,
  };
}

